var _line, _line2, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPHeatingSequenceValves = function SvgPHeatingSequenceValves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 290.1,
    x2: 490,
    y2: 290.1,
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 410,
    y1: 290.1,
    x2: 420,
    y2: 290.1,
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 448.1,
    y1: 304.1,
    x2: 448.1,
    y2: 276.1,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.1,
    y1: 290.1,
    x2: 448.1,
    y2: 290.1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "440.9,303.6 448.1,291.1 455.2,303.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.1,292.1l6.3,11h-12.5L448.1,292.1 M448.1,290.1l-8,14h16L448.1,290.1L448.1,290.1L448.1,290.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "440.9,276.6 455.2,276.6 448.1,289.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.8,277.1h12.5l-6.3,11L441.8,277.1 M440.1,276.1l8,14l8-14H440.1L440.1,276.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M469.1,300.6c-5.8,0-10.5-4.7-10.5-10.5s4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5S474.9,300.6,469.1,300.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.1,280.1c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S463.6,280.1,469.1,280.1 M469.1,279.1c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S475.1,279.1,469.1,279.1L469.1,279.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M467.9,287.2l1.6,4.4l1.6-4.4h1.3v5.7h-1V291l0.1-2.5l-1.7,4.4h-0.7l-1.7-4.4l0.1,2.5v1.9h-1v-5.7H467.9L467.9,287.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 378.1,
    y1: 304.1,
    x2: 378.1,
    y2: 276.1,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.1,
    y1: 290.1,
    x2: 378.1,
    y2: 290.1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "371,303.6 378.1,291.1 385.2,303.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.1,292.1l6.3,11h-12.5L378.1,292.1 M378.1,290.1l-8,14h16L378.1,290.1L378.1,290.1L378.1,290.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "371,276.6 385.2,276.6 378.1,289.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.8,277.1h12.5l-6.3,11L371.8,277.1 M370.1,276.1l8,14l8-14H370.1L370.1,276.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M399.1,300.6c-5.8,0-10.5-4.7-10.5-10.5s4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5S404.9,300.6,399.1,300.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.1,280.1c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S393.6,280.1,399.1,280.1 M399.1,279.1c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S405.2,279.1,399.1,279.1L399.1,279.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M398,287.2l1.6,4.4l1.6-4.4h1.3v5.7h-1V291l0.1-2.5l-1.7,4.4h-0.7l-1.7-4.4l0.1,2.5v1.9h-1v-5.7H398L398,287.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 504.1,
    y1: 258.1,
    x2: 532.1,
    y2: 258.1,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 518.1,
    y1: 258.2,
    x2: 518.1,
    y2: 272.2,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 518.1,
    y1: 248.1,
    x2: 518.1,
    y2: 258.2,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "504.6,251 517.1,258.1 504.6,265.2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.1,251.8l11,6.3l-11,6.3L505.1,251.8 M504.1,250.1v16l14-8L504.1,250.1L504.1,250.1L504.1,250.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "518.1,259.1 525.2,271.6 511,271.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.1,260.1l6.3,11h-12.5L518.1,260.1 M518.1,258.1l-8,14h16L518.1,258.1L518.1,258.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "519.1,258.1 531.6,251 531.6,265.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.1,251.8v12.6l-11-6.3L531.1,251.8 M532.1,250.1l-14,8l14,8V250.1L532.1,250.1L532.1,250.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M518.1,247.6c-5.8,0-10.5-4.7-10.5-10.5s4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5S523.9,247.6,518.1,247.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.1,227.1c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S512.6,227.1,518.1,227.1 M518.1,226.1c-6.1,0-11,4.9-11,11 s4.9,11,11,11c6.1,0,11-4.9,11-11S524.2,226.1,518.1,226.1L518.1,226.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M521,234.4v5.7h-1v-1.9l0.1-2.5l-1.7,4.4h-0.7l-1.7-4.4l0.1,2.5v1.9h-1v-5.7h1.3l1.6,4.4l1.6-4.4H521L521,234.4z"
  }))));
};
export default SvgPHeatingSequenceValves;